import { buildQuestionKey, } from '../types/survey';
const getOptionText = (option) => typeof option === 'string' ? option : option.text;
export const toAnswerIndex = (question, answerValue) => {
    if (question.type === 'multipleChoice') {
        const index = question.options.findIndex((option) => option.text === answerValue);
        return index + 1;
    }
    if (question.type === 'horizontalMultipleChoice') {
        const index = question.options.findIndex((option) => getOptionText(option) === answerValue);
        return index + 1;
    }
    if (question.type === 'nps') {
        const parsed = Number(answerValue);
        if (!Number.isFinite(parsed)) {
            return -1;
        }
        const min = question.min ?? 0;
        const max = question.max ?? 10;
        if (parsed < min || parsed > max) {
            return -1;
        }
        return parsed;
    }
    return 1;
};
const isValidAnswerIndex = (question, answerIndex) => {
    if (!Number.isInteger(answerIndex)) {
        return false;
    }
    if (question.type === 'nps') {
        const min = question.min ?? 0;
        const max = question.max ?? 10;
        return answerIndex >= min && answerIndex <= max;
    }
    return answerIndex >= 1;
};
export const buildSurveyAnswerPayloads = (params) => {
    const { questions, answers, getQuestionKey = buildQuestionKey, toQuestionName = (questionKey) => questionKey, } = params;
    const toPayload = (question, questionKey) => {
        const answerIndex = toAnswerIndex(question, answers[questionKey] ?? '');
        if (!isValidAnswerIndex(question, answerIndex)) {
            throw new Error('Invalid answer index.');
        }
        return {
            questionName: toQuestionName(questionKey),
            answerIndex,
        };
    };
    return questions.flatMap((question, qIndex) => {
        if (question.type === 'container') {
            return question.subQuestions.map((subQuestion, subIndex) => {
                const fallbackKey = `${qIndex}-${subIndex}`;
                const questionKey = getQuestionKey(subQuestion, fallbackKey);
                return toPayload(subQuestion, questionKey);
            });
        }
        const questionKey = getQuestionKey(question, String(qIndex));
        return [toPayload(question, questionKey)];
    });
};
